export const services = [
  { value: 'rentMortgage', text: 'Rent/Mortgage' },
  { value: 'securityDeposit', text: 'Security Deposit' },
  { value: 'utilities', text: 'Utilities' },
  { value: 'carAssistance', text: 'Car Assistance' },
  { value: 'transportation', text: 'Transportation' },
  { value: 'medicalExpenses', text: 'Medical Expenses' },
  { value: 'food', text: 'Food' },
  { value: 'childCare', text: 'Childcare' },
  { value: 'other', text: 'Other' }
]

export const SERVICES = services.map(item => {
  item.group = 'services'
  return item
})
